import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { EasyPosComponent } from './custom_pages/easy-pos/easy-pos.component';

@Injectable({
	providedIn: 'root'
})
export class NavigationPreventorGuard implements CanActivate, CanDeactivate<unknown>
{
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
			return true;
		}
		canDeactivate(
			component: unknown,
			currentRoute: ActivatedRouteSnapshot,
			currentState: RouterStateSnapshot,
			nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
			{
				console.log('Next state', nextState );

				if( component instanceof EasyPosComponent )
				{
					if( nextState.url.indexOf('/pos/pay/pay') === 0 )
					{
						return true;
					}

					if( component.rest.local_preferences.pv_show_all_categories == 'YES' )
						return true;

					if( component.navigation_length > 0 )
					{
						component.navigation_detected = Math.random();
						console.log('FOOO HERE',component.navigation_length);
						return false;
					}
				}
				return true;
			}

}
